import axios from "axios";
import { apiInstanceFetch } from "../../../util/api";
import * as ActionType from "./monetization.type";
import { setToast } from "../../../util/toast";
import { baseURL } from "../../../util/config";
export const getMonetizationRequest =
  (type, start, limit, startDate, endDate) => (dispatch) => {
    axios
      .get(
        `${baseURL}admin/monetizationRequest/getAllMonetizationRequests?type=${type}&start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_MONETIZATION_REQUEST,
          payload: {
            request: res.data.request,
            total: res.data.total,
          },
        });
      })
      .catch((error) => console.error(error));
  };

export const acceptOrDeclineRequest = (id, type, reason) => (dispatch) => {
  axios
    .patch(
      `${baseURL}admin/monetizationRequest/handleMonetizationRequest?monetizationRequestId=${id}&type=${type}&reason=${reason}`
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.ACCEPT_MONETIZATION_REQUEST,
          payload: {
            reqestData: res.data.request,
            requestId: id,
          },
        });
        type === 2
          ? setToast("success", "Request Accept Successfully")
          : setToast("success", "Request Decline Successfully");
      }
    })
    .catch((error) => console.log("error", error));
};
